import { alpha } from '@material-ui/core/styles/colorManipulator';

export default (theme) => ({
  root: {
    position: 'relative',
    width: '100%',
  },
  field: {
    // The global MuiTextField override zeroes the outlined input padding — restore the side inset.
    '& .MuiOutlinedInput-root': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    '& input': {
      padding: '6px 10px 6px 6px',
    },
  },
  searchIcon: {
    color: theme.palette.textColor.secondary,
    pointerEvents: 'none',
  },
  popper: {
    width: '100%',
    zIndex: theme.zIndex.modal,
  },
  paper: {
    maxHeight: 300,
    overflowY: 'auto',
    borderRadius: 3,
    boxShadow: theme.shadows[3],
  },
  option: {
    padding: theme.spacing(1, 2.5),
    fontSize: 14,
    lineHeight: '21px',
    '&:hover': {
      background: alpha(theme.palette.primary.main, 0.06),
    },
  },
  match: {
    color: theme.palette.textColor.primary,
    fontWeight: 500,
  },
  placeholder: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
    fontSize: 14,
    color: theme.palette.textColor.secondary,
  },
});
